import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// const originalPush = Router.prototype.push;
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// };

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      // name: 'index',
      component: () => import('./views/Index.vue'),
      children:[
        {
          path:'',
          redirect:'/home'
        },
        {
          path:'/home',
          name:'home',
          component:()=> import('./views/Home.vue')
        },
        {
          path:'/category',
          name:'category',
          component:()=> import('./views/Category.vue')
        },
        {
          path:'/search',
          name:'search',
          component:()=> import('./views/Search.vue')
        },
        {
          path:'/cart',
          name:'cart',
          component:()=> import('./views/Cart.vue')
        },
        {
          path:'/main',
          name:'main',
          component:()=> import('./views/Main.vue'),
        }
      ]
    },
    {
      path:'/searchResult',
      name:'searchResult',
      component:()=>import('./views/SearchResult.vue')
    },
    {
      path:'/productDetails',
      name:'productDetails',
      meta: {
        keepAlive: true, //该字段表示该页面需要缓存
        isBack: false, //用于判断上一个页面是哪个
        title: '商品详情'
      },
      component:()=>import('./views/ProductDetails.vue')
    },
    {
      path:'/payment',
      name:'payment',
      meta: {
        keepAlive: true,
        isBack: false, 
        title: '订单确认'
      },
      component:()=>import('./views/Payment.vue')
    },
    {
      path:'/address',
      name:'address',
      component:()=>import('./views/address/Address.vue')
    },
    {
      path:'/add-address',
      name:'add-address',
      component:()=>import('./views/address/AddAddress.vue')
    },
    {
      path:'/edit-address',
      name:'edit-address',
      component:()=>import('./views/address/EditAddress.vue')
    },
    {
      path:'/invoice',
      name:'invoice',
      component:()=>import('./views/Invoice.vue')
    },
    {
      path:'/my-order',
      name:'my-order',
      component:()=>import('./views/MyOrder.vue')
    },
    {
      path:'/order-status',
      name:'order-status',
      component:()=>import('./views/OrderStatus.vue')
    },
    {
      path:'/logistics',
      name:'logistics',
      component:()=>import('./views/Logistics.vue')
    },
    {
      path:'/customer-service',
      name:'customer-service',
      component:()=>import('./views/CustomerService.vue')
    },
    {
      path:'/information',
      name:'information',
      component:()=>import('./views/Information.vue')
    },
    {
      path:'/login',
      name:'login',
      component:()=>import('./views/login/Login.vue')
    },
    {
      path:'/phone-login',
      name:'phone-login',
      component:()=>import('./views/login/PhoneLogin.vue')
    },
    {
      path:'/register',
      name:'register',
      component:()=>import('./views/login/Register.vue')
    },
    {
      path:'/offline-pay',
      name:'offline-pay',
      component:()=>import('./views/OfflinePay.vue')
    },
    {
      path:'/alipy',
      name:'alipy',
      component:()=>import('./views/Alipy.vue')
    },
    {
      path:'/success',
      name:'success',
      component:()=>import('./views/Success.vue')
    }
  ]
})
